/** Правила показа коробок. */

/** SSCC группами по четыре: 18 цифр подряд глазом не схватываются.
 *
 * Тот же приём, что у номера паллеты (`boxes/labels.py::group_sscc`, этикетка паллеты) —
 * человек сверяет номер на наклейке с экраном, и делает это глазами.
 */
export function groupSscc(sscc: string): string {
  return (sscc || "").replace(/(\d{4})(?=\d)/g, "$1 ");
}

const ZERO = "00000000-0000-0000-0000-000000000000";

/** Ключ строки состава: (номенклатура, характеристика, партия).
 *
 * ⚠️ Нулевой GUID и пустая строка — одно и то же, иначе ключ не совпадёт с
 * бэкендовым (`boxes/service.py::_key_of`), и «та же строка» перестанет быть
 * той же ровно там, где это незаметно.
 */
export function itemKey(i: {
  nomenclature_ref: string;
  characteristic_ref: string;
  partia_ref: string;
}): string {
  const n = (r: string) => (!r || r === ZERO ? "" : r);
  return `${n(i.nomenclature_ref)}|${n(i.characteristic_ref)}|${n(i.partia_ref)}`;
}

/**
 * Похож ли скан на ЗАВОДСКОЙ КОРОБ, а не на отдельную штуку.
 *
 * ⚠️ Признак — количество больше единицы, и оно приезжает из самого кода:
 * коробочный GS1 несёт `(37)`, а коробочный EAN13 разворачивается в штуки
 * коэффициентом единицы (`qty_base` уже в базовых). Отдельная штука даёт 1.
 *
 * Различать это нужно, потому что заводской короб — единственный физический
 * объект, у которого НЕТ наклейки портала, а разбирать его надо. Пока такого
 * различения не было, экран «Взять из короба» отвечал на его DataMatrix
 * «товарный код, а не наклейка короба» — то есть отказывался делать ровно то,
 * ради чего человек туда зашёл.
 */
export function looksLikeFactoryBox(items: { qty_base: number }[]): boolean {
  return items.length === 1 && Number(items[0]?.qty_base ?? 0) > 1;
}

/**
 * Сколько останется в коробе, если забрать `taken` из `total`.
 *
 * Отдельной функцией — из-за краёв: забрали всё → ноль (короб пуст, коробку в
 * портале заводить нечего), забрали больше, чем есть → отказ, а не
 * отрицательный остаток, который потом уедет на наклейку.
 */
export function boxLeftover(total: number, taken: number): number | null {
  const t = Number(total) || 0;
  const k = Number(taken) || 0;
  if (k < 0 || k > t) return null;
  return t - k;
}
